module.exports = __webpack_public_path__ + "img/Frame_19.bd7e256d.png";